import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll position to the top on every route change.
 *
 * Root cause fix for the mobile "cropped first line" issue:
 * on iPhone the /info form is taller than the viewport, so users
 * scroll down to reach the "Avanti" button. React Router v6 does
 * NOT reset scroll on navigation, so /assessment mounted with a
 * non-zero scrollY, hiding the first line of the question text
 * behind the sticky translucent header.
 *
 * useLayoutEffect fires synchronously BEFORE paint on iOS Safari,
 * preventing any visual flash of the scrolled-down state.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Reset both window scroll and documentElement/body for cross-browser safety
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}
